import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useCurrentClub } from '@/hooks/useCurrentClub';
import { buildPlayEventPublicBoardPath } from '@/lib/playEventBoardPaths';
import { organizationService } from '@/services/organization';
import { playEventService } from '@/services/playEvent';
import { isUuid } from '@/utils/uuid';

export default function PlayEventBoardRedirectPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const { currentClub } = useCurrentClub();
  const [targetPath, setTargetPath] = useState<string | null>(null);
  const eventIdIsValid = isUuid(eventId);

  useEffect(() => {
    if (!currentClub || !eventId || !eventIdIsValid) return undefined;

    let cancelled = false;
    void (async () => {
      const [orgRes, eventRes] = await Promise.all([
        organizationService.getMyOrganization(),
        playEventService.getEvent(currentClub.organizationId, eventId),
      ]);

      if (cancelled) return;

      const orgSlug = orgRes.success && orgRes.data ? orgRes.data.slug : null;
      const eventSlug = eventRes.success && eventRes.data ? eventRes.data.event.slug : null;

      if (orgSlug && eventSlug) {
        setTargetPath(buildPlayEventPublicBoardPath(orgSlug, eventSlug));
      } else {
        setTargetPath('/admin/play-events');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [currentClub, eventId, eventIdIsValid]);

  if (!eventIdIsValid) {
    return <Navigate to="/admin/play-events" replace />;
  }

  if (!targetPath) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0b0d12]">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/20 border-t-amber-400" />
      </div>
    );
  }

  return <Navigate to={targetPath} replace />;
}
